import { Resource as p, API as a } from "@coveo/platform-client";
import { updateMockAgent as l, withDelay as h } from "./AgentConfigurationResource.mocks.js";
import { shouldMockAgentConfiguration as n } from "./ShouldMockAgentConfiguration.js";
const d = 2e3, e = class e extends p {
  /**
   * List agents with optional pagination and sorting.
   *
   * GET /api/preview/organizations/{organizationId}/agents
   *
   * @param {AgentListOptions} options The list options.
   */
  list(t) {
    return this.api.get(this.buildPath(e.baseUrl, t));
  }
  /**
   * Get a single agent by ID.
   *
   * GET /api/preview/organizations/{organizationId}/agents/{agentId}
   *
   * @param {string} agentId The agent ID.
   */
  get(t) {
    return this.api.get(`${e.baseUrl}/${t}`);
  }
  /**
   * Create a new agent.
   *
   * POST /api/preview/organizations/{organizationId}/agents
   *
   * @param {CreateAgentRequest} agent The agent data.
   */
  create(t) {
    return this.api.post(e.baseUrl, t);
  }
  /**
   * Update an existing agent (PATCH).
   *
   * PATCH /api/preview/organizations/{organizationId}/agents/{agentId}
   *
   * Note: followUpEnabled and agentType are NOT modifiable.
   *
   * @param {string} agentId The agent ID.
   * @param {UpdateAgentRequest} agent The updated agent data.
   * @param {MockResponseParams} mockingParams Optional mocking parameters.
   */
  update(t, i, r) {
    if (n(this.api.organizationId, r == null ? void 0 : r.isMocking)) {
      const s = l(t, i);
      return s ? h(s, d) : Promise.reject(new Error(`Agent with ID ${t} not found`));
    }
    return this.api.patch(`${e.baseUrl}/${t}`, i);
  }
  /**
   * Delete an agent.
   *
   * DELETE /api/preview/organizations/{organizationId}/agents/{agentId}
   *
   * @param {string} agentId The agent ID.
   */
  delete(t) {
    return this.api.delete(`${e.baseUrl}/${t}`);
  }
};
e.baseUrl = `/api/preview/organizations/${a.orgPlaceholder}/agents`;
let o = e;
export {
  o as AgentConfigurationResource
};
//# sourceMappingURL=AgentConfigurationResource.js.map
